// extracted by mini-css-extract-plugin
export default {"starter":"App_starter__JF+2C"};